export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/orangeMoney.b4c118ec.svg","height":15,"width":12,"blurWidth":0,"blurHeight":0};